import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BreadcrumbComponent implements OnInit {
  items: MenuItem[] = [];

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateBreadcrumbs();
      });

    // Atualiza ao carregar o componente (por exemplo, em refresh de página)
    this.updateBreadcrumbs();
  }

  private updateBreadcrumbs() {
    this.items = [];

    let currentRoute = this.activatedRoute.root;
    let url = '';

    while (currentRoute.children.length) {
      const childRoute = currentRoute.children[0];
      const routeConfig = childRoute.routeConfig;

      if (routeConfig?.data?.['breadcrumb']) {
        url += '/' + routeConfig.path;

        this.items.push({
          label: routeConfig.data['breadcrumb'],
          routerLink: url,
        });

        if (routeConfig.data['parent']) {
          const { label, route } = routeConfig.data['parent'];
          this.items.splice(this.items.length - 1, 0, {
            label,
            routerLink: route,
          });
        }
      }

      currentRoute = childRoute;
    }

    if (this.items.length > 0) {
      this.items[this.items.length - 1].routerLink = undefined;
    }
  }
}
